import * as React from 'react';

// COMPONENTS
import Button from './Button';

// ICONS
import { ReactComponent as CrossIcon } from '../assets/svg/close-small.svg';

import { ReactComponent as DownloadIcon } from '../assets/svg/download.svg';

// TYPES
interface FileType {
	id?: string;
	displayFileName?: string;
	link?: string;
	name?: string;
	size?: number;
	type?: string;
	uploadInProgress?: boolean;
	percentComplete?: number;
}

interface DownloadRemoveLinkTypes {
	files?: FileType[];
	onChange?: any;
	multiple?: boolean;
	disabled?: boolean;
	downloadOnly?: boolean;
}

// NOTE: files are always passed in as an array, whether there are 1 or many
// The return for the callback will be a string or an array - depending on the multiple property

export const DownloadRemoveLink: React.FC<DownloadRemoveLinkTypes> = ({
	files,
	onChange,
	multiple = false,
	disabled,
	downloadOnly
}) => {
	const [removedFileIds, setRemovedFileIds] = React.useState<string[]>([]);

	const removeFile = (id: string | undefined) => {
		if (id !== undefined) {
			const newRemovedFileIds = removedFileIds.slice();
			newRemovedFileIds.push(id);
			if (onChange) {
				if (multiple) {
					// if multiple - return an array of ids
					onChange(newRemovedFileIds);
				} else {
					// if single - return only id
					onChange(id);
				}
			}

			setRemovedFileIds(newRemovedFileIds);
		}
	};

	return (
		<div className="files-list">
			{files &&
				files.length > 0 &&
				files.map((file, index) => {
					if (!removedFileIds.includes(file.id || '')) {
						return (
							<div key={file.id + '_' + index} className="download-link">
								<span className="link-name">{file.displayFileName ? file.displayFileName : file.name}</span>
								{file.uploadInProgress ? (
									<>
										<span className="progress-bar" style={{ width: file.percentComplete + '%' }}></span>
										<span className="progress-text">{file.percentComplete + '%'}</span>
									</>
								) : (
									<div className="download-link-group">
										<a href={file.link} download>
											<span className="link-text d-none d-lg-block">Download</span>
											<DownloadIcon className="link-icon d-block d-lg-none" />
										</a>
										{!downloadOnly && (
											<Button type="button" className="btn-text small" onClick={() => removeFile(file.id)}>
												<span className="d-none d-lg-block">Remove</span>
												<CrossIcon className="link-icon d-block d-lg-none" />
											</Button>
										)}
									</div>
								)}
							</div>
						);
					} else {
						return null;
					}
				})}
		</div>
	);
};

export default DownloadRemoveLink;
